class onboardingForm extends HTMLElement {
  constructor() {
    super();
    this.$form = this.querySelector("form");
    this.$beginBtn = this.querySelector("#begin-btn");
    this.$progress = this.querySelector("#progress");
    this.$progressBar = this.$progress.querySelector("progress");
    this.$buttonContainer = this.querySelector("#button-container");
    this.$nextBtn = this.querySelector("#next-btn");
    this.$prevBtn = this.querySelector("#prev-btn");
    this.$submitBtn = this.querySelector("#submit-btn");
    this.$inputFields = this.querySelectorAll("input");
    this.currentStep = 0;
    this.totalSteps = this.querySelectorAll("onboarding-step").length - 1;
  }

  connectedCallback() {
    this.$beginBtn.addEventListener("click", this.next.bind(this));
    this.$nextBtn.addEventListener("click", this.next.bind(this));
    this.$prevBtn.addEventListener("click", this.previous.bind(this));
    this.$inputFields.forEach(($input) => {
      $input.addEventListener("change", (event) => {
        this.inputChanged(event.target.name, event.target.value);
      });
    });
    this.$progressBar.style.display = "none";
    this.$buttonContainer.style.display = "none";
    this.$progress.style.display = "none";
  }

  disconnectedCallback() {
    this.$beginBtn.removeEventListener("click", this.next);
    this.$nextBtn.removeEventListener("click", this.next);
    this.$prevBtn.removeEventListener("click", this.previous);
    this.$inputFields.forEach(($input) => {
      $input.removeEventListener("change", this.inputChanged);
    });
  }

  next() {
    this.showStep(++this.currentStep);
    this.updateProgressBar();
  }

  previous() {
    this.showStep(--this.currentStep);
    this.updateProgressBar();
  }

  inputChanged(fieldName, value) {
    this.handleOtherFields(fieldName, value);
  }

  showStep(stepIndex) {
    const $steps = this.querySelectorAll("onboarding-step");
    $steps.forEach(($step, index) => {
      $step.style.display = index === stepIndex ? "block" : "none";
    });
    if (this.currentStep === 0) {
      // welcome step
      this.$beginBtn.style.display = "none";
      this.$progressBar.style.display = "none";
    }
    if (this.currentStep === 1) {
      // first step after begin
      this.$progressBar.style.display = "block";
      this.$buttonContainer.style.display = "flex";
      this.$prevBtn.setAttribute("disabled", "true");
    }
    if (this.currentStep > 1) {
      this.$prevBtn.removeAttribute("disabled");
    }
    if (this.currentStep === this.totalSteps) {
      this.$submitBtn.style.display = "inline-block";
      this.$buttonContainer.style.display = "none";
    }
  }

  updateProgressBar() {
    this.$progress.style.display = "flex";
    if (this.currentStep === 0) {
      this.$progressBar.value = 0;
    } else {
      const progress = (this.currentStep / this.totalSteps) * 100;
      this.$progressBar.value = progress;
    }
  }

  handleOtherFields(fieldName, value) {
    if (fieldName === "user_type") {
      const otherField = document.getElementById("other-user-type-field");
      otherField.style.display = value === "other" ? "block" : "none";
    } else if (fieldName === "app_usage_other") {
      const otherField = document.getElementById("other-app-usage-field");
      otherField.style.display = value ? "block" : "none";
    }
  }
}

customElements.define("onboarding-form", onboardingForm);

export default onboardingForm;
